import { Record1099NEC } from "./interface/1099-NEC-interface";

/**
 * Upload/DB fields not emitted in A2A XML.
 * UN-DEFERRED with the IRS TY2026 package (schema v5.0.6) — now emitted by
 * gen-xml.ts / gen-correction-xml.ts for schema year >= 2026:
 *   BOX1B_CASH_TIPS            -> CashTipsAmt
 *   BOX1C_TTOC1 / BOX1C_TTOC2  -> TreasuryTippedOccupationCd (maxOccurs=2)
 *   BOX1D_OVERTIME_COMPENSATION-> OvertimeCompensationAmt
 * Still deferred (no dedicated XSD elements; address lines cover them):
 */
export const NEC_2026_EFILE_DEFERRED_FIELDS = [
  "FILER_SUITE_NO",
  "FILER_COUNTRY",
  "RECIPIENT_APT_NO",
] as const;

export type Nec2026EfileDeferredField =
  (typeof NEC_2026_EFILE_DEFERRED_FIELDS)[number];

export const resolveNonemployeeCompensationAmt = (
  record: Record1099NEC,
): string =>
  record.BOX1A_NONEMPLOYEE_COMPENSATION ??
  record.BOX1_NONEMPLOYEE_COMPENSATION ??
  "0";
